import { createAsyncThunk } from '@reduxjs/toolkit'
import Notification from './notification-model'
import {
  delete_notification,
  load_notifications,
  store_notification,
} from './notification-service'

export const LoadNotificationsAsync = createAsyncThunk<any, any>(
  'composer/load/notification',
  async (params: { uid: string }) => {
    return await load_notifications(params)
  },
)

export const CreateNotificationAsync = createAsyncThunk<any, any>(
  'composer/create/notification',
  async (params: Notification) => {
    return await store_notification(params)
  },
)

export const DeleteNotificationAsync = createAsyncThunk<any, any>(
  'composer/delete/notification',
  async (params) => {
    return await delete_notification(params)
  },
)
